// extracted by mini-css-extract-plugin
export var locationCard = "_p9-0";